//* get the current timestamp and append it as a query parameter to the base URL for cache busting
export default function getCacheBustedUrl(baseUrl: string): string {
  const timestamp = new Date().getTime(); // Get current timestamp
  return `${baseUrl}?t=${timestamp}`; // Append timestamp as query parameter
}
